(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const content = root.querySelector('[data-guide-content]');
      const toc = root.querySelector('[data-guide-toc]');
      if (!content || !toc) return;
      const heads = content.querySelectorAll('h2');
      if (heads.length < 3) return;
      const list = toc.querySelector('ol');
      heads.forEach((h, i) => {
        if (!h.id) {
          h.id = 'g-' + (h.textContent || String(i))
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
    };
    document.querySelectorAll('[data-guide]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const HEART =
      '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.2 3.1 4.5 6.8 4.5c2.1 0 3.6 1.1 5.2 3 1.6-1.9 3.1-3 5.2-3 3.7 0 5.9 3.7 4.4 7.2C19.5 16.4 12 21 12 21z"/></svg>';
    const COLORS = ['#ff2d55', '#ff5e8a', '#ff9f1a', '#ffd23f', '#7ed321', '#ffffff', '#c084fc'];
    const rand = (a, b) => a + Math.random() * (b - a);
    const pick = (list) => list[Math.floor(Math.random() * list.length)];
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-hero-burst]').forEach((burst) => {
      const hero = burst.closest('.hero');
      const layer = hero.querySelector('[data-hero-hearts]');
      const like = burst.querySelector('[data-hero-like]');
      const counter = burst.querySelector('[data-like-count]');
      let likes = parseInt(counter.dataset.base, 10) || 0;

      const format = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1).replace('.0', '')}K` : `${n}`);
      counter.textContent = format(likes);
      const bump = () => {
        likes += 1;
        counter.textContent = format(likes);
        like.classList.add('is-liked');
        like.classList.remove('is-pop');
        void like.offsetWidth;
        like.classList.add('is-pop');
      };

      const spawn = (x, y, mod, vars = {}) => {
        const h = document.createElement('span');
        h.className = `hero__heart${mod ? ` hero__heart--${mod}` : ''}`;
        h.innerHTML = HEART;
        h.style.left = `${x}px`;
        h.style.top = `${y}px`;
        h.style.setProperty('--c', vars.c || pick(COLORS));
        h.style.setProperty('--dx', `${rand(-3, 3)}rem`);
        h.style.setProperty('--r', `${rand(-22, 22)}deg`);
        h.style.setProperty('--t', `${rand(2.2, 3.4)}s`);
        if (vars.tx) {
          h.style.setProperty('--tx', vars.tx);
          h.style.setProperty('--ty', vars.ty);
        }
        layer.appendChild(h);
        h.addEventListener('animationend', () => h.remove(), { once: true });
      };

      const fromLike = () => {
        const r = like.getBoundingClientRect();
        const l = layer.getBoundingClientRect();
        if (!r.width) return;
        spawn(r.left - l.left + r.width / 2, r.top - l.top + r.height / 3);
      };

      const tapAt = (cx, cy) => {
        const l = layer.getBoundingClientRect();
        const x = cx - l.left;
        const y = cy - l.top;
        spawn(x, y, 'big');
        for (let i = 0; i < 8; i++) {
          const a = (Math.PI * 2 * i) / 8 + rand(-0.2, 0.2);
          const d = rand(3.5, 5.5);
          spawn(x, y, 'spark', { tx: `${Math.cos(a) * d}rem`, ty: `${Math.sin(a) * d}rem` });
        }
        for (let i = 0; i < 3; i++) setTimeout(fromLike, i * 120);
        bump();
      };

      let lastTap = 0;
      let lastX = 0;
      let lastY = 0;
      hero.addEventListener('pointerup', (e) => {
        if (e.target.closest('a, button, input, select, textarea, label')) return;
        const now = performance.now();
        if (now - lastTap < 330 && Math.hypot(e.clientX - lastX, e.clientY - lastY) < 40) {
          tapAt(e.clientX, e.clientY);
          lastTap = 0;
        } else {
          lastTap = now;
          lastX = e.clientX;
          lastY = e.clientY;
        }
      });
      hero.addEventListener('dblclick', (e) => {
        if (!e.target.closest('a, button')) e.preventDefault();
      });

      like.addEventListener('click', () => {
        for (let i = 0; i < 4; i++) setTimeout(fromLike, i * 90);
        bump();
      });

      if (reduce) return;
      let timer;
      new IntersectionObserver(([entry]) => {
        clearInterval(timer);
        if (entry.isIntersecting) {
          timer = setInterval(() => {
            if (document.hidden) return;
            fromLike();
            if (Math.random() < 0.3) {
              likes += 1;
              counter.textContent = format(likes);
            }
          }, 700);
        }
      }).observe(hero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-stats"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ba]').forEach((ba) => {
    const range = ba.querySelector('input[type="range"]');
    if (!range) return;
    let raf = 0;
    const set = (v) => {
      ba.style.setProperty('--ba', v + '%');
      range.value = Math.round(v);
    };
    const current = () => parseFloat(getComputedStyle(ba).getPropertyValue('--ba')) || Number(range.value);

    range.addEventListener('input', () => {
      cancelAnimationFrame(raf);
      ba.classList.add('is-touched');
      ba.style.setProperty('--ba', range.value + '%');
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => ba.classList.toggle('is-paused', !entry.isIntersecting)).observe(ba);
    }

    const play = document.querySelector(`[data-ba-play][aria-controls="${ba.id}"]`);
    if (!play) return;
    const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
    play.addEventListener('click', () => {
      const from = current();
      cancelAnimationFrame(raf);
      ba.classList.add('is-touched');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        set(from > 50 ? 0 : 100);
        return;
      }
      // Full "before", then a slow wipe to "after", then back to the middle
      const frames = [
        [from, 100, 900],
        [100, 100, 600],
        [100, 0, 2600],
        [0, 0, 900],
        [0, 50, 800],
      ];
      let i = 0;
      let start = performance.now();
      play.classList.add('is-playing');
      const step = (now) => {
        const [a, b, d] = frames[i];
        const t = Math.min(1, (now - start) / d);
        set(a + (b - a) * ease(t));
        if (t >= 1) {
          i += 1;
          start = now;
        }
        if (i < frames.length) {
          raf = requestAnimationFrame(step);
        } else {
          play.classList.remove('is-playing');
        }
      };
      raf = requestAnimationFrame(step);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ingredients]').forEach((root) => {
    const buttons = root.querySelectorAll('[data-filter]');
    const cards = root.querySelectorAll('[data-formulas]');
    buttons.forEach((btn) =>
      btn.addEventListener('click', () => {
        const f = btn.dataset.filter;
        buttons.forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn);
        });
        cards.forEach((c) => {
          c.hidden = f !== 'all' && !c.dataset.formulas.includes(f);
        });
      })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;
    const track = bar.querySelector('[data-track]');
    const slides = [...bar.querySelectorAll('[data-slide]')];
    const dots = [...bar.querySelectorAll('.sticky-cta__dots i')];
    const cta = bar.querySelector('[data-cta]');
    const ctaPrice = bar.querySelector('[data-cta-price]');
    let index = 0;

    const setActive = (i) => {
      index = i;
      const slide = slides[i];
      if (!slide) return;
      cta.href = slide.dataset.url;
      if (ctaPrice) ctaPrice.textContent = slide.dataset.price || '';
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    const go = (i) => {
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(n);
    };
    setActive(0);

    if (slides.length > 1) {
      const io = new IntersectionObserver(
        (entries) => entries.forEach((e) => e.isIntersecting && setActive(slides.indexOf(e.target))),
        { root: track, threshold: 0.6 }
      );
      slides.forEach((sl) => io.observe(sl));
      bar.querySelector('[data-prev]')?.addEventListener('click', () => go(index - 1));
      bar.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let paused = false;
      ['pointerenter', 'touchstart', 'focusin'].forEach((ev) => bar.addEventListener(ev, () => (paused = true), { passive: true }));
      ['pointerleave', 'focusout'].forEach((ev) => bar.addEventListener(ev, () => (paused = false)));
      if (!reduced) {
        setInterval(() => {
          if (!paused && bar.classList.contains('is-visible')) go(index + 1);
        }, 4200);
      }
    }

    if (!('IntersectionObserver' in window)) return;
    const hero = document.querySelector('.hero');
    const blockers = [...document.querySelectorAll(bar.dataset.hideOn + ', .shopify-section-group-footer-group, footer')];
    let pastHero = false;
    const blocked = new Set();
    const sync = () => {
      const show = pastHero && blocked.size === 0;
      bar.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('has-sticky-cta', show);
    };
    bar.hidden = false;
    if (hero) {
      new IntersectionObserver(([e]) => {
        pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        sync();
      }).observe(hero);
    } else {
      pastHero = true;
    }
    const bio = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? blocked.add(e.target) : blocked.delete(e.target)));
      sync();
    });
    blockers.forEach((el) => bio.observe(el));
  })();

  } catch(e) { console.error(e); }
})();
})();
